/* eslint-disable react/prop-types */
import React from 'react'

function DrawingControl({ drawing }) {
  return (
    <div className="m-2">
      <button
        className="btn btn-action tooltip tooltip-left"
        data-tooltip="Desenhar novo polígono"
        type="button"
        onClick={drawing.startPolygon}
        disabled={!drawing.ready}
      >
        <i className="fas fa-draw-polygon" />
      </button>
    </div>
  )
}

export default DrawingControl
